import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

export interface MobileReleaseVersion {
  mobileReleaseVersionId?: string;
  versionNumber: string;
  dateReleased?: string | Date;
  insertDate?: string | Date;
  active: boolean;
}

@Injectable({ providedIn: 'root' })
export class MobileReleaseVersionsService {
  private readonly baseUrl = environment.APIEndPoint + 'MobileReleaseVersion/';

  constructor(private http: HttpClient) {}

  getAllVersions(): Observable<MobileReleaseVersion[]> {
    return this.http.get<any>(this.baseUrl + 'GetAllVersions').pipe(
      map(response => response && response.primaryReturn ? response.primaryReturn : [])
    );
  }

  save(version: MobileReleaseVersion): Observable<MobileReleaseVersion> {
    return this.http.post<any>(this.baseUrl + 'SaveVersion', version).pipe(
      map(response => {
        const primaryReturn = response && response.primaryReturn;
        return Array.isArray(primaryReturn) ? primaryReturn[0] : primaryReturn;
      })
    );
  }
}
